export const SCHEDULER_URL = 'https://calendar.app.google/KMtQpVFGaNZPAY3p8';
